export default "__VITE_ASSET__WMQMeB7P__"